import {ErrorHandler, NgModule} from '@angular/core';

import {AuthInterceptor} from '@q9elements/ui-kit/common';
import {AppErrorHandler} from './app-error-handler';
import {provideErrorInterceptor} from './interceptors/error.interceptor';

@NgModule({
  providers: [
    AuthInterceptor,
    provideErrorInterceptor(),
    {provide: ErrorHandler, useClass: AppErrorHandler}
  ]
})
export class RMECoreModule {}
